module.exports = __webpack_public_path__ + "img/lucky-draw-intro-popup.46cfdbe.png";